import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import MyTrips from "../components/MyTrips";

export default function MyTripsPage({
  user,
  posts = [],
  users = [],
  onOpenUser,
  setShowSidebar,
  onRootTabSelect,
  onSidebarRouteNavigate,
  enableDesktopRightRail = false,
  desktopRightRailTargetId,
  useShellChrome = false,
}) {
  const navigate = useNavigate();

  const handleCloseTrips = useCallback(() => {
    navigate("/", { replace: true });
  }, [navigate]);

  return (
    <MyTrips
      user={user}
      posts={posts}
      users={users}
      onOpenUser={onOpenUser}
      setShowTrips={handleCloseTrips}
      setShowSidebar={setShowSidebar}
      onRootTabSelect={onRootTabSelect}
      onSidebarRouteNavigate={onSidebarRouteNavigate}
      enableDesktopRightRail={enableDesktopRightRail}
      desktopRightRailTargetId={desktopRightRailTargetId}
      useShellChrome={useShellChrome}
    />
  );
}
